/**
 * Enumeration of the possible statuses of a store entity.
 * ADO #2618525: Remove the usage of this enum in favor of `StoreEntityState`.
 * @deprecated Use `StoreEntityState` instead.
 */ export var StoreEntityStatus = /*#__PURE__*/ function(StoreEntityStatus) {
    /** Entity has not been fetched and its status is unknown */ StoreEntityStatus["Unfetched"] = "U";
    /** Entity is being fetched */ StoreEntityStatus["Fetching"] = "F";
    /** Entity is present in the store */ StoreEntityStatus["Present"] = "P";
    /** Entity is present in the store but is soft deleted */ StoreEntityStatus["SoftDeleted"] = "SD";
    /** Fetch for the entity failed */ StoreEntityStatus["UnableToFetch"] = "UF";
    /** Fetch for the entity failed due to it being inaccessible for the user */ StoreEntityStatus["Inaccessible"] = "I";
    /** Fetch for the entity failed due to it not being found */ StoreEntityStatus["NotFound"] = "NF";
    /** Entity is stale and expired */ StoreEntityStatus["Stale"] = "S";
    return StoreEntityStatus;
}({});
/**
 * Represents the current in-memory state of the store entity.
 */ export var StoreEntityState = /*#__PURE__*/ function(StoreEntityState) {
    /** Entity is not present in the store */ StoreEntityState["Absent"] = "A";
    /** Entity is present in the store */ StoreEntityState["Present"] = "P";
    /** Entity is present in the store but is soft deleted */ StoreEntityState["SoftDeleted"] = "SD";
    /** Fetch for the entity failed */ StoreEntityState["UnableToFetch"] = "UF";
    /** Fetch for the entity failed due to it being inaccessible for the user */ StoreEntityState["Inaccessible"] = "I";
    /** Fetch for the entity failed due to it not being found */ StoreEntityState["NotFound"] = "NF";
    /** Entity is marked as dirty due to a failed update operation and must be re-fetched from the service */ StoreEntityState["Dirty"] = "D";
    return StoreEntityState;
}({});
export const failedStoreEntityStates = [
    "I",
    "NF",
    "SD",
    "UF"
];
export const failedStoreEntityStatuses = [
    "I",
    "NF",
    "SD",
    "UF"
];
/**
 * Mru collection key enum
 */ export var MruStoreCollectionKey = /*#__PURE__*/ function(MruStoreCollectionKey) {
    MruStoreCollectionKey["MRU_COLLECTION"] = "MRU_COLLECTION";
    return MruStoreCollectionKey;
}({});
/**
 * My day user key
 */ export var MyDayUser = /*#__PURE__*/ function(MyDayUser) {
    MyDayUser["CURRENT_USER"] = "CURRENT_USER";
    return MyDayUser;
}({});
export var TableName = /*#__PURE__*/ function(TableName) {
    /** Mru Store */ TableName["Mru"] = "mru";
    /** Pinned Tasks Store (local-only favorites for the new My Tasks experience) */ TableName["PinnedTasks"] = "pinnedTasks";
    /** My Tasks Order Store (local-only My Tasks reorder overrides) */ TableName["TaskOrder"] = "taskOrder";
    /** Saved Dynamic Filters Store (local-only saved Catalyst prompts) */ TableName["DynamicFilter"] = "dynamicFilters";
    /** Task Store */ TableName["Tasks"] = "task";
    TableName["LoopPageUrl"] = "loopPageUrl";
    /** Plan Store */ TableName["Plan"] = "plan";
    TableName["PlannerDefaultPlanId"] = "plannerDefaultPlanId";
    /** Permissions Store */ TableName["PlanSensitivityUserRights"] = "planSensitivityUserRights";
    TableName["CopilotEligibility"] = "copilotEligibility";
    TableName["UserEntitlements"] = "userEntitlements";
    /** Bucket Store */ TableName["Bucket"] = "bucket";
    /** Goal Store */ TableName["Goal"] = "goal";
    /** Roster Store */ TableName["Roster"] = "roster";
    TableName["RosterMembers"] = "rosterMembers";
    /** Chat Store */ TableName["ChatMessage"] = "chatMessage";
    TableName["ChatMessageNextLink"] = "chatMessageNextLink";
    TableName["EmojiMetadata"] = "EmojiMetadata";
    /** History Store */ TableName["History"] = "history";
    TableName["HistoryFetchMetadata"] = "historyFetchMetadata";
    /** Auth Store */ TableName["AccessTokens"] = "access-tokens";
    /** External Agent Store */ TableName["ExternalAgents"] = "externalAgents";
    /** Capabilities Store */ TableName["TodoCapabilities"] = "todoCapabilities";
    /** Dependency Store */ TableName["Dependency"] = "dependencies";
    /** Template Store */ TableName["TemplateStatus"] = "templateStatus";
    TableName["Templates"] = "templates";
    TableName["TemplateSearchByMicrosoft"] = "templateSearchByMicrosoft";
    TableName["TemplateSearchSharedWithMe"] = "templateSearchSharedWithMe";
    TableName["TemplateSearchCreatedByMe"] = "templateSearchCreatedByMe";
    /** Operation Tracking Store */ TableName["Operations"] = "operations";
    /** Upsell Store */ TableName["UserProjectSubscriptionStatus"] = "user-subscription-status";
    /** Teams Store */ TableName["TeamsTasksTabs"] = "teamsTasksTabs";
    TableName["TeamsMessageDetails"] = "teamsMessageDetails";
    TableName["MeetingDetails"] = "meetingDetails";
    TableName["TeamsChatMembers"] = "teamsChatMembers";
    /** Teams Channel Store */ TableName["TeamsChannelMembers"] = "teamsChannelMembers";
    TableName["TeamsChannels"] = "teamsChannels";
    TableName["TeamsChannelFilesFolders"] = "teamsChannelFilesFolders";
    /** Tenant Store */ TableName["TenantFeatureSettings"] = "tenant-feature-settings";
    TableName["TenantFeedbackSettings"] = "tenant-feedback-settings";
    TableName["TenantGroupSettings"] = "tenant-group-settings";
    TableName["SensitivityLabels"] = "sensitivity-labels";
    TableName["SensitivityPolicySettings"] = "sensitivity-policy-settings";
    TableName["FilSensitivityLabels"] = "file-sensitivity-labels";
    TableName["FileSensitivityPolicySettings"] = "file-sensitivity-policy-settings";
    TableName["TenantPortfoliosEnabled"] = "tenant-portfolios-enabled";
    TableName["OrganizationInfo"] = "organization-info";
    /** Plan Conversion Store */ TableName["PlanConversion"] = "plan-conversions";
    /** Premium Plan Store */ TableName["PremiumPlan"] = "premiumPlan";
    TableName["PremiumPlansSharedWithUser"] = "premiumPlansSharedWithUser";
    TableName["PremiumPlansCreatedByUser"] = "premiumPlansCreatedByUser";
    /** DriveItem Store */ TableName["DriveItem"] = "drive-item";
    TableName["UploadSession"] = "upload-session";
    TableName["SiteUrl"] = "site-url";
    TableName["Permission"] = "permission";
    TableName["Thumbnail"] = "thumbnail";
    TableName["DriveItemSensitiveLabels"] = "drive-item-sensitive-labels";
    /** Portfolio Store */ TableName["Portfolios"] = "portfolios";
    /** Modern Groups Store */ TableName["ModernGroups"] = "modernGroups";
    TableName["SiteUrlAndDriveIds"] = "modernGroupSiteUrlAndDriveId";
    TableName["ModernGroupOwners"] = "modernGroupOwners";
    TableName["ModernGroupMembers"] = "modernGroupMembers";
    TableName["OneDriveUrls"] = "modernGroupOneDriveUrl";
    TableName["UserMembershipSlice"] = "userMembership";
    /** User Store */ TableName["Users"] = "users";
    TableName["UserPhotos"] = "userPhotos";
    TableName["ContainerUsers"] = "containerUsers";
    TableName["UserSearch"] = "userSearch";
    TableName["UserSettings"] = "userSettings";
    TableName["RoamingData"] = "roamingData";
    TableName["LandingPageNotificationSettings"] = "landingPageNotificationSettings";
    /** Todo Store */ TableName["TodoMembers"] = "todoMembers";
    /** Trouter Store */ TableName["TrouterSubscription"] = "trouterSubscription";
    /** View store */ TableName["ViewConfig"] = "viewConfig";
    /** View store — globally-scoped (non per-view) persisted settings, keyed by GlobalViewSettingKeys */ TableName["GlobalViewSettings"] = "globalViewSettings";
    /** Custom Field Definition Store */ TableName["CustomFieldDefinitions"] = "customFieldDefinitions";
    return TableName;
}({});
/** Enum for store table names */ export var StoreTableNames = /*#__PURE__*/ function(StoreTableNames) {
    /** Mru Store tables */ StoreTableNames["Mru"] = "mru";
    StoreTableNames["MruCollectionStatus"] = "mruCollectionStatus";
    /** Plan Store tables */ StoreTableNames["Plans"] = "plans";
    StoreTableNames["PlanDetails"] = "planDetails";
    StoreTableNames["PlanStatus"] = "planStatus";
    StoreTableNames["MoveBasicPlanOperationStatus"] = "moveBasicPlanOperationStatus";
    StoreTableNames["ContainerStatus"] = "containerStatus";
    StoreTableNames["ContainerFailureStatus"] = "containerFailureStatus";
    StoreTableNames["PlansInContainerStatus"] = "plansInContainerStatus";
    StoreTableNames["PlansInContainerLastPageStatus"] = "plansInContainerLastPageStatus";
    StoreTableNames["CreatePlanFromTaskOperationStatus"] = "createPlanFromTaskOperationStatus";
    StoreTableNames["CreatePlanFromTemplateOperationStatus"] = "createPlanFromTemplateOperationStatus";
    StoreTableNames["ExtendPlanExpiryOperationStatus"] = "extendPlanExpiryOperationStatus";
    /** Bucket store tables */ StoreTableNames["Buckets"] = "buckets";
    StoreTableNames["BucketStatus"] = "bucketStatus";
    StoreTableNames["BucketsInPlanStatus"] = "bucketsInPlanStatus";
    /** ChecklistItem store tables */ StoreTableNames["ChecklistItems"] = "checklistItems";
    StoreTableNames["ChecklistItemStatus"] = "checklistItemStatus";
    StoreTableNames["ChecklistItemsInTaskStatus"] = "checklistItemsInTaskStatus";
    /** UserAssignment store tables */ StoreTableNames["UserAssignments"] = "userAssignments";
    StoreTableNames["UserAssignmentStatus"] = "userAssignmentStatus";
    StoreTableNames["UserAssignmentsInTaskStatus"] = "UserAssignmentsInTaskStatus";
    /** ExternalAgents */ StoreTableNames["ExternalAgent"] = "externalAgent";
    /** Goals store tables */ StoreTableNames["Goals"] = "goals";
    StoreTableNames["GoalStatus"] = "goalStatus";
    StoreTableNames["GoalsInPlanStatus"] = "goalsInPlanStatus";
    /** Task store tables */ StoreTableNames["Tasks"] = "tasks";
    StoreTableNames["TaskDetails"] = "taskDetails";
    StoreTableNames["TaskApprovalDetails"] = "taskApprovalDetails";
    StoreTableNames["TaskboardTaskFormatForAssignedTo"] = "taskboardTaskFormatForAssignedTo";
    StoreTableNames["TaskboardTaskFormatForBucket"] = "taskboardTaskFormatForBucket";
    StoreTableNames["TaskboardTaskFormatForProgress"] = "taskboardTaskFormatForProgress";
    StoreTableNames["IsApprovalOperationInProgress"] = "isApprovalOperationInProgress";
    StoreTableNames["TaskApprovalDetailsStatus"] = "taskApprovalDetailsStatus";
    StoreTableNames["TaskStatus"] = "taskStatus";
    StoreTableNames["TasksInPlanStatus"] = "tasksInPlanStatus";
    StoreTableNames["TasksByAssigneeStatus"] = "tasksByAssigneeStatus";
    StoreTableNames["TasksInMyDayStatusTable"] = "tasksInMyDayStatusTable";
    /** Chat store tables */ StoreTableNames["ChatMessages"] = "chatMessages";
    StoreTableNames["ChatMessagesForTaskStatus"] = "chatMessagesForTaskStatus";
    StoreTableNames["ChatMessageStatus"] = "chatMessageStatus";
    StoreTableNames["ChatMessageNextLink"] = "chatMessageNextLink";
    /** Loop store tables */ StoreTableNames["LoopPageUrlForTask"] = "loopPageUrlForTask";
    StoreTableNames["LoopPageUrlStatus"] = "loopPageUrlStatus";
    /** Content link store tables */ StoreTableNames["ContentLinks"] = "contentLinks";
    StoreTableNames["ContentLinkStatus"] = "contentLinkStatus";
    StoreTableNames["ContentLinksInTaskStatus"] = "contentLinksInTaskStatus";
    StoreTableNames["ContentLinksInPlanStatus"] = "contentLinksInPlanStatus";
    /** View store tables */ StoreTableNames["ViewContexts"] = "viewContexts";
    StoreTableNames["FilterExceptions"] = "filterExceptions";
    StoreTableNames["MyPlansTeamsExpandedState"] = "myPlansTeamsExpandedState";
    /** Task suggestion generation status */ StoreTableNames["TaskSuggestionGenerationStatus"] = "taskSuggestionGenerationStatus";
    return StoreTableNames;
}({});
/** Default plan ID */ export const DefaultPlanId = "defaultPlanId";
/** FlaggedEmail plan ID */ export const FlaggedEmailPlanId = "flaggedEmailPlanId";
/** Index value to get all basic plans */ export const BasicPlan = "BasicPlan";
/** Mock store entity status for a present entity; used in tests to mock return values of the store */ export const STORE_ENTITY_STATUS_PRESENT = {
    isFetching: false,
    state: "P",
    timestamp: null
};
/** Mock store entity status for a absent entity; used in tests to mock return values of the store */ export const STORE_ENTITY_STATUS_ABSENT = {
    isFetching: false,
    state: "A",
    timestamp: null
};
